import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

import { GasColor } from '../../../core/colors/color.namespace';
import { GasYears } from '../gas-datepicker.interface';

const MAX_YEARS = 20;
const MIN_YEARS = 3;

@Component({
  selector: 'gas-year',
  templateUrl: './gas-year.component.html',
  styleUrls: ['../gas-datepicker.component.scss', './gas-year.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasYearComponent implements OnChanges {
  @Input()
  public currentYear: number = null;

  @Output()
  public onChangeYear: EventEmitter<number> = new EventEmitter();

  public gasColor = GasColor.Color;
  public yearOptions = {} as GasYears;

  /** Меняем актуальные данные при изменении currentYear */
  public ngOnChanges(changes: SimpleChanges): void {
    this.currentYear = changes?.currentYear.currentValue;
    this.setYearsOptions();
  }

  /** настраиваем объект с актуальными данными */
  public setYearsOptions(): void {
    this.yearOptions.currentYear = this.currentYear;
    this.yearOptions.minYear = this.currentYear - MIN_YEARS;
    this.yearOptions.maxYear = this.currentYear +  MAX_YEARS;

    this.createYearData();
  }

  /** заполняем массив списком годов для рендеринга на странице */
  public createYearData(): void {
    this.yearOptions.years = [];

    for (let i = this.yearOptions.minYear; i <= this.yearOptions.maxYear; i++) {
      this.yearOptions.years.push(i);
    }
  }

  /** меняем период в зависимости от нажатия на стрелку и запускаем метод по наполнению массива годами */
  public changeYearPeriod(step: number): void {
    if (step > 0) {
      this.yearOptions.minYear = this.yearOptions.maxYear + step;
      this.yearOptions.maxYear = this.yearOptions.minYear + MAX_YEARS + MIN_YEARS;
    } else {
      this.yearOptions.maxYear = this.yearOptions.minYear + step;
      this.yearOptions.minYear = this.yearOptions.maxYear - MAX_YEARS - MIN_YEARS;
    }

    this.createYearData();
  }

  /** если пользователь выбирает год - эмитим его наверх */
  public changeYear(year: number): void {
    this.currentYear = year;
    this.onChangeYear.emit(+year);
  }

  /** если пользователь нажал кнопку назад - эмитим наверх текущий год */
  public backToDatepicker(): void {
    this.onChangeYear.emit(+this.yearOptions.currentYear);
  }
}
